export const settings = {
    baseServingSize: 8,
    servingSizes: [4, 8, 16]
}